import {
  MapPin,
  Route,
  Clock,
  Receipt,
  Bell,
  DollarSign,
  LayoutDashboard,
  FileText,
  HardHat,
  Wrench,
  Truck,
  Briefcase,
  SprayCan,
  ShieldCheck,
  Home,
  Package,
  HeartPulse,
  Zap,
  Target,
  Users,
  UserCheck,
  Calculator,
  Eye,
  CreditCard,
  ClipboardCheck,
  Banknote,
} from "lucide-react";

export const featurePages = [
  {
    slug: "live-gps-tracking",
    icon: MapPin,
    gradient: "from-blue-500 to-blue-600",
    shadowColor: "shadow-blue-500/30",
    ns: "features",
    key: "liveGps",
  },
  {
    slug: "route-history",
    icon: Route,
    gradient: "from-indigo-500 to-indigo-600",
    shadowColor: "shadow-indigo-500/30",
    ns: "features",
    key: "routeHistory",
  },
  {
    slug: "attendance-tracking",
    icon: Clock,
    gradient: "from-green-500 to-emerald-600",
    shadowColor: "shadow-green-500/30",
    ns: "features",
    key: "attendance",
  },
  {
    slug: "expense-management",
    icon: Receipt,
    gradient: "from-orange-500 to-red-500",
    shadowColor: "shadow-orange-500/30",
    ns: "features",
    key: "expense",
  },
  {
    slug: "job-site-alerts",
    icon: Bell,
    gradient: "from-amber-500 to-orange-600",
    shadowColor: "shadow-amber-500/30",
    ns: "features",
    key: "jobSiteAlerts",
  },
  {
    slug: "collection-management",
    icon: DollarSign,
    gradient: "from-purple-500 to-pink-600",
    shadowColor: "shadow-purple-500/30",
    ns: "features",
    key: "collection",
  },
  {
    slug: "admin-dashboard",
    icon: LayoutDashboard,
    gradient: "from-cyan-500 to-blue-600",
    shadowColor: "shadow-cyan-500/30",
    ns: "features",
    key: "adminDashboard",
  },
  {
    slug: "payroll-integration",
    icon: FileText,
    gradient: "from-violet-500 to-purple-600",
    shadowColor: "shadow-violet-500/30",
    ns: "features",
    key: "payroll",
  },
];

export const industryPages = [
  {
    slug: "construction",
    icon: HardHat,
    gradient: "from-yellow-500 to-orange-600",
    shadowColor: "shadow-yellow-500/30",
    ns: "industries",
    key: "construction",
  },
  {
    slug: "hvac-plumbing",
    icon: Wrench,
    gradient: "from-blue-500 to-cyan-600",
    shadowColor: "shadow-blue-500/30",
    ns: "industries",
    key: "hvacPlumbing",
  },
  {
    slug: "delivery-logistics",
    icon: Truck,
    gradient: "from-green-500 to-emerald-600",
    shadowColor: "shadow-green-500/30",
    ns: "industries",
    key: "deliveryLogistics",
  },
  {
    slug: "field-sales",
    icon: Briefcase,
    gradient: "from-purple-500 to-indigo-600",
    shadowColor: "shadow-purple-500/30",
    ns: "industries",
    key: "fieldSales",
  },
  {
    slug: "cleaning-maintenance",
    icon: SprayCan,
    gradient: "from-teal-500 to-green-600",
    shadowColor: "shadow-teal-500/30",
    ns: "industries",
    key: "cleaningMaintenance",
  },
  {
    slug: "security-services",
    icon: ShieldCheck,
    gradient: "from-red-500 to-rose-600",
    shadowColor: "shadow-red-500/30",
    ns: "industries",
    key: "securityServices",
  },
  {
    slug: "real-estate",
    icon: Home,
    gradient: "from-amber-500 to-yellow-600",
    shadowColor: "shadow-amber-500/30",
    ns: "industries",
    key: "realEstate",
  },
  {
    slug: "fmcg-distribution",
    icon: Package,
    gradient: "from-orange-500 to-red-600",
    shadowColor: "shadow-orange-500/30",
    ns: "industries",
    key: "fmcgDistribution",
  },
  {
    slug: "healthcare-homecare",
    icon: HeartPulse,
    gradient: "from-pink-500 to-rose-600",
    shadowColor: "shadow-pink-500/30",
    ns: "industries",
    key: "healthcareHomecare",
  },
  {
    slug: "electrical-services",
    icon: Zap,
    gradient: "from-yellow-400 to-amber-600",
    shadowColor: "shadow-yellow-400/30",
    ns: "industries",
    key: "electricalServices",
  },
];

export const comparisonPages = [
  {
    slug: "trackteam-vs-hubstaff",
    competitor: "Hubstaff",
    ns: "comparisons",
    key: "hubstaff",
  },
  {
    slug: "trackteam-vs-connecteam",
    competitor: "Connecteam",
    ns: "comparisons",
    key: "connecteam",
  },
  {
    slug: "trackteam-vs-jibble",
    competitor: "Jibble",
    ns: "comparisons",
    key: "jibble",
  },
  {
    slug: "trackteam-vs-timeero",
    competitor: "Timeero",
    ns: "comparisons",
    key: "timeero",
  },
  {
    slug: "trackteam-vs-clockshark",
    competitor: "ClockShark",
    ns: "comparisons",
    key: "clockshark",
  },
];

export const solutionPages = [
  {
    slug: "transparent-tracking",
    icon: Eye,
    gradient: "from-green-500 to-emerald-600",
    shadowColor: "shadow-green-500/30",
    ns: "solutions",
    key: "transparentTracking",
  },
  {
    slug: "field-expense-tracking",
    icon: CreditCard,
    gradient: "from-orange-500 to-red-500",
    shadowColor: "shadow-orange-500/30",
    ns: "solutions",
    key: "fieldExpenseTracking",
  },
  {
    slug: "visit-verification",
    icon: ClipboardCheck,
    gradient: "from-blue-500 to-indigo-600",
    shadowColor: "shadow-blue-500/30",
    ns: "solutions",
    key: "visitVerification",
  },
  {
    slug: "workforce-attendance",
    icon: UserCheck,
    gradient: "from-purple-500 to-violet-600",
    shadowColor: "shadow-purple-500/30",
    ns: "solutions",
    key: "workforceAttendance",
  },
  {
    slug: "automated-payroll",
    icon: Banknote,
    gradient: "from-emerald-500 to-teal-600",
    shadowColor: "shadow-emerald-500/30",
    ns: "solutions",
    key: "automatedPayroll",
  },
];

export const personaPages = [
  {
    slug: "operations-managers",
    icon: Target,
    gradient: "from-blue-500 to-indigo-600",
    shadowColor: "shadow-blue-500/30",
    ns: "personas",
    key: "operationsManagers",
  },
  {
    slug: "business-owners",
    icon: Briefcase,
    gradient: "from-purple-500 to-violet-600",
    shadowColor: "shadow-purple-500/30",
    ns: "personas",
    key: "businessOwners",
  },
  {
    slug: "field-supervisors",
    icon: Users,
    gradient: "from-green-500 to-emerald-600",
    shadowColor: "shadow-green-500/30",
    ns: "personas",
    key: "fieldSupervisors",
  },
  {
    slug: "hr-managers",
    icon: UserCheck,
    gradient: "from-orange-500 to-amber-600",
    shadowColor: "shadow-orange-500/30",
    ns: "personas",
    key: "hrManagers",
  },
  {
    slug: "finance-teams",
    icon: Calculator,
    gradient: "from-cyan-500 to-blue-600",
    shadowColor: "shadow-cyan-500/30",
    ns: "personas",
    key: "financeTeams",
  },
];

export function getFeatureBySlug(slug) {
  return featurePages.find((f) => f.slug === slug);
}

export function getIndustryBySlug(slug) {
  return industryPages.find((i) => i.slug === slug);
}

export function getComparisonBySlug(slug) {
  return comparisonPages.find((c) => c.slug === slug);
}

export function getSolutionBySlug(slug) {
  return solutionPages.find((s) => s.slug === slug);
}

export function getPersonaBySlug(slug) {
  return personaPages.find((p) => p.slug === slug);
}
